import React from "react";
import { GeoJSON } from "react-leaflet";
import { styleDrawnPolygonGeoJson } from "../../../utils/polygons/polygonStyle";
import { connect } from "react-redux";

class DrawnPolygonGeoJson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const filtered = this.getFilteredDrawnGeoJson();
    if (
      filtered.features.length !== 0 &&
      this.props.drawnPolygonGeoJsonRef.current !== null
    ) {
      this.props.drawnPolygonGeoJsonRef.current.leafletElement
        .clearLayers()
        .addData(filtered);
    }
  }

  getFilteredDrawnGeoJson() {
    const {
      drawnPolygonGeojsonWg,
      hiddenDrawnPolygonTypesIndexes,
      allDrawnObjectsVisibility,
    } = this.props;
    if (
      !allDrawnObjectsVisibility ||
      !drawnPolygonGeojsonWg?.features ||
      !Array.isArray(drawnPolygonGeojsonWg.features)
    ) {
      return { type: "FeatureCollection", features: [] };
    }
    const features = drawnPolygonGeojsonWg.features.filter(
      (f) => !hiddenDrawnPolygonTypesIndexes.includes(f.properties?.t)
    );
    return { type: "FeatureCollection", features };
  }

  componentDidUpdate(prevProps) {
    const filtered = this.getFilteredDrawnGeoJson();
    if (
      this.props.inRasterSettingsMode &&
      this.props.drawnPolygonGeoJsonRef.current !== null
    ) {
      this.props.drawnPolygonGeoJsonRef.current.leafletElement
        .clearLayers()
        .addData(filtered);
      return;
    }

    if (
      prevProps.hiddenDrawnPolygonTypesIndexes !==
        this.props.hiddenDrawnPolygonTypesIndexes ||
      prevProps.drawnPolygonGeojsonWg !== this.props.drawnPolygonGeojsonWg
    ) {
      if (this.props.drawnPolygonGeoJsonRef.current !== null) {
        this.props.drawnPolygonGeoJsonRef.current.leafletElement
          .clearLayers()
          .addData(filtered);
      }
      return;
    }

    if (
      prevProps.drawnPolygonGeojsonWg.features.length !==
        this.props.drawnPolygonGeojsonWg.features.length &&
      prevProps.drawnPolygonGeojsonWg.features.length === 0 &&
      this.props.drawnPolygonGeoJsonRef.current !== null
    ) {
      this.props.drawnPolygonGeoJsonRef.current.leafletElement
        .clearLayers()
        .addData(filtered);
      return;
    }

    if (
      (this.props.drawnPolygonGeojsonWg.features.length !== 0 ||
        this.props.drawnPolygonGeojsonWg !== prevProps.drawnPolygonGeojsonWg) &&
      this.props.drawnPolygonGeoJsonRef.current !== null
    ) {
      this.props.drawnPolygonGeoJsonRef.current.leafletElement
        .clearLayers()
        .addData(filtered);
      return;
    }
  }

  render() {
    const filtered = this.getFilteredDrawnGeoJson();
    return (
      <>
        {this.props.isDrawnGeoJsonVisible && (
          <GeoJSON
            ref={this.props.drawnPolygonGeoJsonRef}
            data={filtered}
            style={(x) => {
              return styleDrawnPolygonGeoJson(
                x,
                this.props.selectedMapItemGeoProps?.id === x?.properties?.id,
                this.props.inputPalmTypesPalette
              );
            }}
            onEachFeature={this.props.onEachFeature}
            zIndex={1000000}
          />
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    drawnPolygonGeojsonWg: state.map.drawnPolygonGeojsonWg,
    inRasterSettingsMode: state.map.inRasterSettingsMode,
    allDrawnObjectsVisibility: state.legend.allDrawnObjectsVisibility,
    hiddenDrawnPolygonTypesIndexes:
      state.legend.hiddenDrawnPolygonTypesIndexes,
    isDrawnGeoJsonVisible: state.rasterArea.isDrawnGeoJsonVisible,
    selectedMapItemGeoProps: state.map.selectedMapItemGeoProps,
    inputPalmTypesPalette:
      state.userSettings?.settings?.visualizationPresets?.inputPalmTypesPalette || {},
  };
};

export default connect(mapStateToProps, null)(DrawnPolygonGeoJson);
